import { createSlice } from '@reduxjs/toolkit';
const initialState = { apiErrors: [] };
const slice = createSlice({
    name: 'errors',
    initialState,
    reducers: {
        addApiError: (state, action) => {
            state.apiErrors.push(action.payload);
        },
        clearApiErrors: (state) => {
            state.apiErrors = [];
        },
    },
});
export const { addApiError, clearApiErrors } = slice.actions;
export default slice;
